import { FC, KeyboardEvent } from 'react';
import { useStyles } from './styles';
import { ConfirmActionDialogProps } from './types';
import { Button, Grid, Paper, Modal, Checkbox, FormGroup, FormControlLabel } from '@material-ui/core';
import { observer } from 'mobx-react-lite';

export const ConfirmActionDialog: FC<ConfirmActionDialogProps> = observer(
  ({
    label,
    buttonLabel,
    openModal,
    action,
    handleClose,
    notify,
    notifyStatus,
    appnotify,
    carlicense,
    appnotifyStatus,
    reSyncProvider,
    gitStatus,
  }) => {
    const classes = useStyles();
    const handelAction = () => {
      if (action) {
        action();
      }
      handleClose();
    };

    const handleKeyPressed = (event: KeyboardEvent<HTMLDivElement>) => {
      if (event.code === 'Enter') {
        handelAction();
      }
    };

    return (
      <Modal
        className={classes.modal}
        disablePortal
        disableEnforceFocus
        open={openModal}
        onEscapeKeyDown={handleClose}
        onKeyDownCapture={handleKeyPressed}
      >
        <Paper className={classes.paper} elevation={3}>
          <p className={classes.title}>{label}</p>
          {notify !== undefined && (
            <div>
              <FormGroup row>
                <FormControlLabel
                  className={classes.notify}
                  control={
                    <Checkbox
                      checked={notify}
                      onChange={(event) => notifyStatus?.(event.target.checked)}
                      name='notfiy'
                      defaultChecked={false}
                    />
                  }
                  label='Notify End User via Email'
                />
              </FormGroup>
              {gitStatus === 'invited' && (
                <p style={{ color: 'red' }}>
                  This user has been invited to GitHub but hasn't accepted yet, so we can't make changes to the account.
                </p>
              )}
            </div>
          )}
          {appnotify !== undefined && carlicense !== 'admin' && reSyncProvider && reSyncProvider.length > 0 && (
            <>
              <FormGroup>
                <FormControlLabel
                  className={classes.notify}
                  control={
                    <Checkbox
                      checked={appnotify}
                      onChange={(event) => appnotifyStatus?.(event.target.checked)}
                      name='appStatus'
                      defaultChecked={false}
                    />
                  }
                  label='Do you want to delete on third party app ?'
                />
              </FormGroup>
            </>
          )}
          <Grid className={classes.marginTop} container justify='space-between'>
            <Button className={classes.actionBtn} variant='contained' color='primary' onClick={handelAction}>
              {buttonLabel}
            </Button>
            <Button className={classes.cancelButton} onClick={handleClose}>
              Cancel
            </Button>
          </Grid>
        </Paper>
      </Modal>
    );
  }
);
